import type { NavItem } from '@/app/nav';

const matchesPath = (pathname: string, path: string): boolean => {
    if (!path) return false;
    return path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`);
};

const linkedPathsOf = (items: NavItem[]): string[] =>
    items.flatMap((nav) =>
        nav.subItems ? nav.subItems.map((subItem) => subItem.path) : nav.path ? [nav.path] : []
    );

export const activeNavPath = (items: NavItem[], pathname: string): string | null =>
    linkedPathsOf(items)
        .filter((path) => matchesPath(pathname, path))
        .reduce<string | null>(
            (best, path) => (best === null || path.length > best.length ? path : best),
            null
        );
